import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LogisticsFacilityService {

  baseUrl: string = `${environment.logisticsApiUrl}/facility`;

  constructor(private http: HttpClient) {

  }

  /**
   * Get facility dropdown list options by country name.
   */
  getFacilityOptions(): Observable<any> {
    const url = this.baseUrl + `/facilityOptions`;
    return this.http.post(url, null);
  }

}
